export default __webpack_public_path__ + "static/media/grafema_minha-casa_11.a5eba257.jpg";